/*##########################################################################
// Image Scale
//#########################################################################*/

import { scroll, transform } from "motion"

const imageScale = {
	config: {
		attr: "image-scale-on-scroll",
	},

	init() {
		const images = document.querySelectorAll(`[${this.config.attr}]`)

		// Map scroll progress [0 → 1] to scale [1.22 → 1]
		const mapProgressToScale = transform(
			[0, 1],
			[1.22, 1],
			{ clamp: true }
		)

		images.forEach((image) => {
			scroll(
				(progress) => {
					const scale = mapProgressToScale(progress)
					// Use the new individual transform property
					image.style.scale = scale
				},
				{
					target: image,
					offset: ["start end", "end 33%"],
				}
			)
		})
	},
}

initComponent(() => {
	imageScale.init()
})


